<template>
	<div>
		<div class="bg-gradient-warning text-center text-white w-100 p-3" v-if="isLoading">
			{{ loadingMessage }}
			<i class="fas fa-spinner fa-spin"> </i>
		</div>

		<b-card class="p-0">
			<b-card-header class="text-right p-0 badge-group-flex">
				<b-badge
					variant="primary"
					class="m-1 cursor-pointer"
					v-b-modal.hss-info
					v-on:click="getHssInfoDetail(detailInfo['IMSI'])"
				>
					<i class="fa fa-file text-dark"></i>
					HSS
				</b-badge>
				<b-badge
					v-if="!isIOTOnly"
					variant="info"
					class="m-1 cursor-pointer"
					v-b-modal.hlr-info
					v-on:click="getHlrInfoDetail(detailInfo['IMSI'])"
				>
					<i class="fa fa-file text-dark"></i>
					HLR
				</b-badge>
				<b-badge
					variant="warning"
					class="m-1 cursor-pointer"
					v-b-modal.session-info
					v-on:click="getSessionDetail(detailInfo['IMSI'])"
				>
					<i class="fa fa-file text-dark"></i>
					Session
				</b-badge>
				<b-badge
					variant="success"
					class="m-1 cursor-pointer"
					v-b-modal.sms-activity
					v-on:click="getSmsActivityDetail(detailInfo['IMSI'])"
				>
					<i class="fa fa-file text-dark"></i>
					SMS Activity
				</b-badge>
				<b-badge
					variant="primary"
					class="m-1 cursor-pointer"
					v-b-modal.view-map
					v-on:click="getMapDetail(detailInfo['IMSI'])"
				>
					<i class="fa fa-globe text-dark"></i>
					View Map
				</b-badge>
				<b-badge
					v-if="!isIOTOnly"
					variant="info"
					class="m-1 cursor-pointer"
					v-b-modal.send-sms
					v-on:click="getSmsDetail(detailInfo['MSISDN'])"
				>
					<i class="fa fa-paper-plane text-dark"></i>
					Send SMS
				</b-badge>
				<b-badge
					v-if="!isIOTOnly"
					variant="warning"
					class="m-1 cursor-pointer"
					v-b-modal.cancel-location
					v-on:click="setCancelLocation(imsi)"
				>
					<i class="fa fa-times-circle text-dark"></i>
					Cancel Location
				</b-badge>
				<b-badge
					v-if="!isIOTOnly"
					variant="success"
					class="m-1 cursor-pointer"
					v-b-modal.send-psi
					v-on:click="sendPSI(imsi)"
				>
					<i class="fas fa-edit text-dark"></i>
					Send PSI
				</b-badge>
			</b-card-header>

			<b-card-body class="p-0">
				<div class="p-2">
					<b-row>
						<b-col :xl="isIOTOnly ? 6 : 7">
							<b-row>
								<b-col :xl="isIOTOnly ? 6 : 4" :md="isIOTOnly ? 6 : 4">
									<b-row v-if="url" class="text-nowrap text-sm no-gutters">
										<b-col cols="auto">
											<span class="font-weight-900">IMSI:</span>
										</b-col>
										<b-col cols="auto" class="pl-1">
											<span>{{ imsi }}</span> <br />
											<span>{{ roamingImsi }} *</span> <br />
											<small>* Denotes Roaming IMSI</small>
										</b-col>
									</b-row>
									<p v-else class="text-sm"><span class="font-weight-900">IMSI:</span> {{ imsi }}</p>
									<p class="text-sm">
										<span class="font-weight-900">ICCID:</span> {{ detailInfo["ICCID"] }}
									</p>
									<p class="text-sm">
										<span class="font-weight-900">MSISDN:</span> {{ detailInfo["MSISDN"] }}
									</p>
									<p class="text-sm">
										<span class="font-weight-900">SMS Activity:</span>
										<span> {{ simUsage["SMS Inbox"] }}</span>
										<small>(last 24 hours) </small>
									</p>

									<p class="text-sm" v-if="!isIOTOnly">
										<span class="font-weight-900">Subscriber Name:</span>
										<span> {{ subscriber_name }}</span>
									</p>
								</b-col>
								<b-col :xl="isIOTOnly ? 6 : 4" :md="isIOTOnly ? 6 : 4">
									<p class="text-sm">
										<span class="font-weight-900">IP:</span> {{ detailInfo["IP"] }}
									</p>
									<p class="text-sm">
										<span class="font-weight-900">APN:</span> {{ detailInfo["Cell ID"] }}
									</p>
									<p class="text-sm">
										<span class="font-weight-900">SIM Type:</span> {{ detailInfo["SIM Type"] }}
										<span v-if="showQRCodeStatus">
											<base-button
												type="warning"
												title="show QR code"
												size="sm"
												v-on:click="getProfile(detailInfo['ICCID'])"
											>
												<i class="fas fa-qrcode"> </i>
											</base-button>
										</span>
									</p>
									<p class="text-sm">
										<span class="font-weight-900">Product:</span>
										{{ detailInfo["Product"] }}
									</p>
									<p class="text-sm nowrap" v-if="!isIOTOnly">
										<span class="font-weight-900 mr-2">HLR Product:</span> <br />
										<b-form-select
											size="sm"
											class="mt-3"
											style="width: 150px"
											value-field="key"
											text-field="value"
											v-model="hlrProfileSelected"
											:options="hlrProfileOptions"
											:disabled="showLoadingHlrProfile || stateReadOnly"
											@change="setHlrProfile(hlrProfileSelected, detailInfo['IMSI'])"
										>
										</b-form-select>
										<base-button
											type="primary"
											:title="
												showLoadingHlrProfile || isLoading
													? 'loading drop down'
													: 'refresh drop down'
											"
											size="sm"
											v-on:click="getHlrProfile()"
											:loading="showLoadingHlrProfile || isLoading"
											:disabled="stateReadOnly"
										>
											<i v-if="!showLoadingHlrProfile && !isLoading" class="fas fa-search"> </i>
										</base-button>
									</p>
								</b-col>
								<b-col xl="4" md="4" v-if="!isIOTOnly">
									<p class="text-sm nowrap" v-if="hasDataPlans">
										<span class="font-weight-900 mr-2">Data Plan:</span> <br />
										<b-form-select
											size="sm"
											class="mt-3"
											style="width: 150px"
											value-field="key"
											text-field="value"
											v-model="dataPlanSelected"
											:options="dataPlanOptions"
											:disabled="showLoadingDataPlans || stateReadOnly"
											@change="setDataPlan(dataPlanSelected, detailInfo['IMSI'])"
										>
										</b-form-select>
										<base-button
											type="primary"
											:title="
												showLoadingDataPlans || isLoading
													? 'loading drop down'
													: 'refresh drop down'
											"
											size="sm"
											v-on:click="getDataPlans()"
											:loading="showLoadingDataPlans || isLoading"
											:disabled="stateReadOnly"
										>
											<i v-if="!showLoadingDataPlans && !isLoading" class="fas fa-search"> </i>
										</base-button>
									</p>
									<p class="text-sm nowrap">
										<span class="font-weight-900 mr-2">Data Speed:</span> <br />
										<b-form-select
											size="sm"
											class="mt-3"
											style="width: 150px"
											value-field="key"
											text-field="value"
											v-model="hssProfileSelected"
											:options="hssProfileOptions"
											:disabled="showLoadingHssProfile || stateReadOnly"
											@change="setHssProfile(hssProfileSelected, detailInfo['IMSI'])"
										>
										</b-form-select>
										<base-button
											type="primary"
											:title="
												showLoadingHssProfile || isLoading
													? 'loading drop down'
													: 'refresh drop down'
											"
											size="sm"
											v-on:click="getHssProfile()"
											:loading="showLoadingHssProfile || isLoading"
											:disabled="stateReadOnly"
										>
											<i v-if="!showLoadingHssProfile && !isLoading" class="fas fa-search"> </i>
										</base-button>
									</p>
									<p v-if="hasDataPlans" class="text-sm">
										<span class="font-weight-900">Data Balance:</span>
										{{ detailDataInfo["balance"] }}
									</p>
									<p class="text-sm">
										<span class="font-weight-900">Data Usage:</span> {{ simUsage["Usage"] }}
										<small>(last 30 days) </small>
									</p>
								</b-col>
							</b-row>
						</b-col>
						<b-col :xl="isIOTOnly ? 6 : 5">
							<b-row>
								<b-col xl="6" md="4">
									<p class="text-sm" v-if="isIOTOnly">
										<span class="font-weight-900">Data Usage:</span> {{ simUsage["Usage"] }}
										<small>(last 30 days) </small>
									</p>
									<p class="text-sm">
										<span class="font-weight-900">Manufacturer:</span>
										{{ detailOperator["manufacturer"] }}
									</p>
									<p class="text-sm">
										<span class="font-weight-900">Model:</span> {{ detailOperator["model"] }}
									</p>
									<p class="text-sm">
										<span class="font-weight-900">OS:</span> {{ detailOperator["OS"] }}
									</p>
									<p class="text-sm d-flex" v-if="has_local_data && !isIOTOnly">
										<span class="font-weight-900 mr-5">Local Data Only : </span>
										<b-form-checkbox
											v-model="localDataChecked"
											name="check-button"
											switch
											class="mr-2"
											:disabled="simStatus || stateReadOnly"
											@change="setLocalData(localDataChecked, detailInfo['IMSI'])"
										>
										</b-form-checkbox>
									</p>
								</b-col>
								<b-col xl="6" md="4">
									<p class="text-sm">
										<span class="font-weight-900">Brand:</span> {{ detailOperator["brand"] }}
									</p>
									<p class="text-sm">
										<span class="font-weight-900">RAT:</span> {{ detailOperator["rat"] }}
									</p>
									<p class="text-sm">
										<span class="font-weight-900">Band:</span> {{ detailOperator["bands"] }}
									</p>
								</b-col>
							</b-row>
						</b-col>
					</b-row>

					<b-card class="p-0" v-if="!isIOTOnly">
						<b-card-body class="p-0">
							<b-row>
								<b-col sm="2">
									<b class="nowrap">2G/3G Data</b>
									<p class="mt-3 text-sm d-flex">
										<span class="mr-5">
											{{ gStatus ? "Active" : "Inactive" }}
										</span>
										<b-form-checkbox
											v-model="gStatus"
											name="check-button"
											switch
											:disabled="simStatus || stateReadOnly"
											class="mr-2"
											@change="setModifySubscriber('2G_3G_Status', gStatus)"
										>
										</b-form-checkbox>
									</p>
								</b-col>
								<b-col sm="2">
									<b>LTE Data</b>
									<p class="mt-3 text-sm d-flex">
										<span class="mr-5">
											{{ lteStatus ? "Active" : "Inactive" }}
										</span>
										<b-form-checkbox
											v-model="lteStatus"
											name="check-button"
											switch
											:disabled="simStatus || stateReadOnly"
											class="mr-2"
											@change="setModifySubscriber('LTE_Status', lteStatus)"
										>
										</b-form-checkbox>
									</p>
								</b-col>
								<b-col sm="2" v-if="url">
									<b>International Roaming</b>
									<p class="mt-3 text-sm d-flex">
										<span class="mr-5">
											{{ tisStatus ? "Active" : "Inactive" }}
										</span>
										<b-form-checkbox
											v-model="tisStatus"
											name="check-button"
											switch
											:disabled="simStatus || stateReadOnly"
											class="mr-2"
											@change="setModifySubscriber('SetTIS', tisStatus)"
										>
										</b-form-checkbox>
									</p>
								</b-col>
								<b-col sm="2">
									<b>SMS</b>
									<p class="mt-3 text-sm d-flex">
										<span class="mr-5">
											{{ smsStatus ? "Yes" : "No" }}
										</span>
										<b-form-checkbox
											v-model="smsStatus"
											name="check-button"
											switch
											:disabled="simStatus || stateReadOnly"
											class="mr-2"
											@change="setModifySubscriber('SMS', smsStatus)"
										>
										</b-form-checkbox>
									</p>
								</b-col>
								<b-col sm="2">
									<b class="nowrap">Call Waiting</b>
									<p class="mt-3 text-sm d-flex">
										<span class="mr-5">
											{{ callWaitingStatus ? "Yes" : "No" }}
										</span>
										<b-form-checkbox
											v-model="callWaitingStatus"
											name="check-button"
											switch
											:disabled="simStatus || stateReadOnly"
											class="mr-2"
											@change="setModifySubscriber('Call_Waiting', callWaitingStatus)"
										>
										</b-form-checkbox>
									</p>
								</b-col>
								<b-col sm="2">
									<b>CLIP</b>
									<p class="mt-3 text-sm d-flex">
										<span class="mr-5">
											{{ clipStatus ? "Yes" : "No" }}
										</span>
										<b-form-checkbox
											v-model="clipStatus"
											name="check-button"
											switch
											:disabled="simStatus || stateReadOnly"
											class="mr-2"
											@change="setModifySubscriber('Clip', clipStatus)"
										>
										</b-form-checkbox>
									</p>
								</b-col>
								<b-col sm="2">
									<b>MMS</b>
									<p class="mt-3 text-sm d-flex">
										<span class="mr-5">
											{{ mmsStatus ? "Yes" : "No" }}
										</span>
										<b-form-checkbox
											v-model="mmsStatus"
											name="check-button"
											switch
											:disabled="simStatus || stateReadOnly"
											class="mr-2"
											@change="setModifySubscriber('MMS', mmsStatus)"
										>
										</b-form-checkbox>
									</p>
								</b-col>
							</b-row>
							<b-row>
								<b-col xl="12" class="text-left m-0 mt-3">
									<span class="h4">Call Forwarding</span>
									<b-tabs content-class="mt-3" class="mt-3">
										<b-tab title="Not Available" active>
											<b-row>
												<b-col md="4">
													<b>Provisioned</b>
													<p class="mt-3 text-sm d-flex">
														<span class="mr-5">
															{{ cfnaProvisionedStatus ? "Yes" : "No" }}
														</span>
														<b-form-checkbox
															v-model="cfnaProvisionedStatus"
															name="check-button"
															switch
															class="mr-2"
															:disabled="simStatus || stateReadOnly"
															@change="
																setModifySubscriber(
																	'CFNA_Provisioned',
																	cfnaProvisionedStatus
																)
															"
														>
														</b-form-checkbox>
													</p>
												</b-col>
												<b-col md="4" xl="2">
													<b>Number</b>
													<p class="mt-3 text-sm">
														<b-input-group label-for="input-1" class="d-flex">
															<b-form-input
																id="input-1"
																size="sm"
																type="number"
																:state="cfnaNumberValidate"
																:disabled="simStatus || stateReadOnly"
																v-model="cfnaNumber"
															></b-form-input>
															<b-input-group-append>
																<base-button
																	type="outline-success"
																	title="Number"
																	size="sm"
																	class="simDetailCard-Number"
																	v-on:click="
																		setCallingForward(
																			'CFNA_Number',
																			cfnaNumberValidate,
																			cfnaNumber
																		)
																	"
																	:disabled="simStatus || stateReadOnly"
																>
																	<b-icon icon="vector-pen" variant="danger"></b-icon>
																</base-button>
															</b-input-group-append>
														</b-input-group>
													</p>
												</b-col>
												<b-col md="4">
													<b>Active</b>
													<p class="mt-3 text-sm d-flex">
														<span class="mr-5">
															{{ cfnaActiveStatus ? "Yes" : "No" }}
														</span>
														<b-form-checkbox
															v-model="cfnaActiveStatus"
															name="check-button"
															switch
															:disabled="simStatus || stateReadOnly"
															class="mr-2"
															@change="
																setModifySubscriber('CFNA_Active', cfnaActiveStatus)
															"
														>
														</b-form-checkbox>
													</p>
												</b-col>
											</b-row>
										</b-tab>
										<b-tab title="Busy">
											<b-row>
												<b-col md="4">
													<b>Provisioned</b>
													<p class="mt-3 text-sm d-flex">
														<span class="mr-5">
															{{ cfnaProvisionedStatus ? "Yes" : "No" }}
														</span>
														<b-form-checkbox
															v-model="cfbProvisionedStatus"
															name="check-button"
															switch
															class="mr-2"
															:disabled="simStatus || stateReadOnly"
															@change="
																setModifySubscriber(
																	'CFB_Provisioned',
																	cfbProvisionedStatus
																)
															"
														>
														</b-form-checkbox>
													</p>
												</b-col>
												<b-col md="4" xl="2">
													<b>Number</b>
													<p class="mt-3 text-sm">
														<b-input-group label-for="input-1" class="d-flex">
															<b-form-input
																id="input-1"
																size="sm"
																class="simDetailCard-Number"
																:disabled="simStatus || stateReadOnly"
																:state="cfbNumberValidate"
																v-model="cfbNumber"
															></b-form-input>
															<b-input-group-append>
																<base-button
																	type="outline-success"
																	title="Number"
																	size="sm"
																	v-on:click="
																		setCallingForward(
																			'CFB_Number',
																			cfbNumberValidate,
																			cfbNumber
																		)
																	"
																	:disabled="simStatus || stateReadOnly"
																>
																	<b-icon icon="vector-pen" variant="danger"></b-icon>
																</base-button>
															</b-input-group-append>
														</b-input-group>
													</p>
												</b-col>
												<b-col md="4">
													<b>Active</b>
													<p class="mt-3 text-sm d-flex">
														<span class="mr-5">
															{{ cfbActiveStatus ? "Yes" : "No" }}
														</span>
														<b-form-checkbox
															v-model="cfbActiveStatus"
															name="check-button"
															switch
															:disabled="simStatus || stateReadOnly"
															class="mr-2"
															@change="setModifySubscriber('CFB_Active', cfbActiveStatus)"
														>
														</b-form-checkbox>
													</p>
												</b-col>
											</b-row>
										</b-tab>
										<b-tab title="Not Reachable">
											<b-row>
												<b-col md="4">
													<b>Provisioned</b>
													<p class="mt-3 text-sm d-flex">
														<span class="mr-5">
															{{ cfnrProvisionedStatus ? "Yes" : "No" }}
														</span>
														<b-form-checkbox
															v-model="cfnrProvisionedStatus"
															name="check-button"
															switch
															class="mr-2"
															:disabled="simStatus || stateReadOnly"
															@change="
																setModifySubscriber(
																	'CFNR_Provisioned',
																	cfnrProvisionedStatus
																)
															"
														>
														</b-form-checkbox>
													</p>
												</b-col>
												<b-col md="4" xl="2">
													<b>Number</b>
													<p class="mt-3 text-sm">
														<b-input-group label-for="input-1" class="d-flex">
															<b-form-input
																id="input-1"
																size="sm"
																class="simDetailCard-Number"
																:state="cfnrNumberValidate"
																:disabled="simStatus || stateReadOnly"
																v-model="cfnrNumber"
															></b-form-input>
															<b-input-group-append>
																<base-button
																	type="outline-success"
																	title="Number"
																	size="sm"
																	v-on:click="
																		setCallingForward(
																			'CFNR_Number',
																			cfnrNumberValidate,
																			cfnrNumber
																		)
																	"
																	:disabled="simStatus || stateReadOnly"
																>
																	<b-icon icon="vector-pen" variant="danger"></b-icon>
																</base-button>
															</b-input-group-append>
														</b-input-group>
													</p>
												</b-col>
												<b-col md="4">
													<b>Active</b>
													<p class="mt-3 text-sm d-flex">
														<span class="mr-5">
															{{ cfnrActiveStatus ? "Yes" : "No" }}
														</span>
														<b-form-checkbox
															v-model="cfnrActiveStatus"
															name="check-button"
															switch
															:disabled="simStatus || stateReadOnly"
															class="mr-2"
															@change="
																setModifySubscriber('CFNR_Active', cfnrActiveStatus)
															"
														>
														</b-form-checkbox>
													</p>
												</b-col>
											</b-row>
										</b-tab>
										<b-tab title="Unconditional">
											<b-row>
												<b-col md="4">
													<b>Provisioned</b>
													<p class="mt-3 text-sm d-flex">
														<span class="mr-5">
															{{ cfuProvisionedStatus ? "Yes" : "No" }}
														</span>
														<b-form-checkbox
															v-model="cfuProvisionedStatus"
															name="check-button"
															switch
															class="mr-2"
															:disabled="simStatus || stateReadOnly"
															@change="
																setModifySubscriber(
																	'CFU_Provisioned',
																	cfuProvisionedStatus
																)
															"
														>
														</b-form-checkbox>
													</p>
												</b-col>
												<b-col md="4" xl="2">
													<b>Number</b>
													<p class="mt-3 text-sm">
														<b-input-group label-for="input-1" class="d-flex">
															<b-form-input
																id="input-1"
																size="sm"
																:state="cfuNumberValidate"
																v-model="cfuNumber"
																:disabled="simStatus || stateReadOnly"
															></b-form-input>
															<b-input-group-append>
																<base-button
																	type="outline-success"
																	title="Number"
																	size="sm"
																	class="simDetailCard-Number"
																	v-on:click="
																		setCallingForward(
																			'CFU_Number',
																			cfuNumberValidate,
																			cfuNumber
																		)
																	"
																	:disabled="simStatus || stateReadOnly"
																>
																	<b-icon icon="vector-pen" variant="danger"></b-icon>
																</base-button>
															</b-input-group-append>
														</b-input-group>
													</p>
												</b-col>
												<b-col md="4">
													<b>Active</b>
													<p class="mt-3 text-sm d-flex">
														<span class="mr-5">
															{{ cfuActiveStatus ? "Yes" : "No" }}
														</span>
														<b-form-checkbox
															v-model="cfuActiveStatus"
															name="check-button"
															switch
															:disabled="simStatus || stateReadOnly"
															class="mr-2"
															@change="setModifySubscriber('CFU_Active', cfuActiveStatus)"
														>
														</b-form-checkbox>
													</p>
												</b-col>
											</b-row>
										</b-tab>
									</b-tabs>
								</b-col>
							</b-row>
						</b-card-body>
					</b-card>
				</div>

				<!--        </b-overlay>-->

				<div v-if="simDetailFailed" class="text-center mt-2">
					<i class="fas fa-exclamation-triangle text-yellow" aria-hidden="true"></i><br />
					<span class="ml-2 mr-2 h4 text-danger"
						>We were unable to load your data. Please contact support if you need assistance with this
						error.</span
					>
				</div>
			</b-card-body>
		</b-card>

		<b-modal
			centered
			size="lg"
			id="view-map"
			title="View Map"
			class="view-map"
			ok-variant="secondary"
			ok-only
			ok-title="Close"
		>
			<ViewMap></ViewMap>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="send-sms"
			hide-footer
			title="Send SMS"
			class="send-sms"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Send"
		>
			<SendSMS :msisdn="detailInfo['MSISDN']"></SendSMS>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="session-info"
			title="Session Data"
			class="session-info"
			ok-variant="secondary"
			ok-only
			ok-title="Close"
		>
			<SessionInfo></SessionInfo>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="sms-activity"
			title="SMS Activity"
			class="sms-activity"
			ok-variant="secondary"
			ok-only
			ok-title="Close"
		>
			<SMSActivity></SMSActivity>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="hlr-info"
			title="HLR Info"
			class="hlr-info"
			ok-only
			ok-variant="secondary"
			ok-title="Close"
		>
			<HLRInfo></HLRInfo>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="hss-info"
			title="HSS Info"
			class="hlr-info"
			ok-only
			ok-variant="secondary"
			ok-title="Close"
		>
			<HSSInfo></HSSInfo>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="cancel-location"
			hide-footer
			title="Cancel Voice/Data for an IMSI"
			class="cancel-location"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<CancelLocation></CancelLocation>
		</b-modal>

		<b-modal
			centered
			size="lg"
			id="send-psi"
			hide-footer
			title="Provide Subscriber Info for an IMSI"
			class="send-psi"
			cancel-title="Close"
			ok-variant="primary"
			ok-title="Submit"
		>
			<SendPSI></SendPSI>
		</b-modal>
	</div>
</template>

<script>
import configDirective from "../../../common/directive/config-directive";
import searchDashboardService from "@/common/api-services/search-dashboard-service";
import HSSInfo from "../../Components/Provisioning-HSS-Info";
import HLRInfo from "../../Components/Provisioning-HLR-Info";
import ViewMap from "../../Components/Provisioning-View-Map";
import SendSMS from "../../Components/Provisioning-Send-SMS";
import SessionInfo from "../../Components/Provisioning-Session-Info";
import SMSActivity from "../../Components/Provisioning-SMS-Activity";
import CancelLocation from "../../Components/Provisioning-Cancel-Location";
import SendPSI from "../../Components/Provisioning-Send-PSI";
import searchDetailService from "@/common/api-services/search-details-service";
import provisioningService from "@/common/api-services/provisioning-service";
import initService from "@/common/api-services/init-service";
import commonService from "@/common/api-services/common";
import ToastVue from "../../Components/Toast.vue";
//import hssProfile from "@/views/Pages/HSS/hssProfile";

export default {
	name: "SimDetailCard",
	components: {
		//ChangeDataSpeed,
		SendPSI,
		CancelLocation,
		SMSActivity,
		SessionInfo,
		HSSInfo,
		HLRInfo,
		ViewMap,
		SendSMS,
		ToastVue,
	},
	computed: {
		cfnaNumberValidate() {
			if (this.cfnaNumber) {
				return this.cfnaNumber === "0" || this.cfnaNumber.length === 11;
			}
		},
		cfbNumberValidate() {
			if (this.cfbNumber) {
				return this.cfbNumber === "0" || this.cfbNumber.length === 11;
			}
		},
		cfnrNumberValidate() {
			if (this.cfnrNumber) {
				return this.cfnrNumber === "0" || this.cfnrNumber.length === 11;
			}
		},
		cfuNumberValidate() {
			if (this.cfuNumber) {
				return this.cfuNumber === "0" || this.cfuNumber.length === 11;
			}
		},
	},

	data() {
		return {
			isIOTOnly: false,
			hasDataPlans: true,
			hasNsim: false,
			detailInfo: [],
			subscriber_name: "",
			detailSubscriber: [],
			detailDataInfo: [],
			simUsage: [],
			hss_profile_badge_title: null,
			detailOperator: [],
			isLoading: true,
			localDataChecked: true,
			localDataOnly: "",
			gStatus: true,
			lteStatus: true,
			tisStatus: false,
			smsStatus: true,
			callWaitingStatus: true,
			clipStatus: true,
			mmsStatus: true,
			cfnaActiveStatus: true,
			cfnaNumber: 0,
			cfnaProvisionedStatus: true,
			cfbActiveStatus: true,
			cfbNumber: 0,
			cfbProvisionedStatus: true,
			cfnrActiveStatus: true,
			cfnrNumber: 0,
			cfnrProvisionedStatus: true,
			cfuActiveStatus: true,
			cfuNumber: 0,
			cfuProvisionedStatus: true,
			hlrProfileSelected: false,
			hlrProfile: "",
			hlrProfileOptions: [],
			hssProfileSelected: false,
			hssProfile: "",
			hssProfileOptions: [],
			dataPlanSelected: false,
			dataPlan: "",
			dataPlanOptions: [],
			imsi: "",
			simStatus: true,
			roamingImsi: "",
			roamingStatus: false,
			has_local_data: false,
			simDetailFailed: false,
			isAdminStatus: false,
			loadingMessage: "",
			showLoadingHssProfile: true,
			showLoadingHlrProfile: true,
			showLoadingDataPlans: true,
			stateReadOnly: true,
			showQRCodeStatus: false,
			lastMessage: "",
			progressMessage: "",
			progressStartValue: 5,
			url: null,
		};
	},

	async mounted() {
		this.hasNsim = configDirective.hasNsim();
		this.hasDataPlans = configDirective.hasDataPlans();
		this.isIOTOnly = configDirective.isIOTOnly();
		this.loadingMessage = "Loading SIM settings...";
		this.isLoading = true;
		this.stateReadOnly = true;

		if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] mounted...", Date());

		//hide local data
		if (configDirective.getConfigData()["site-settings"]["has_local_data"]) {
			this.has_local_data = true;
			//console.log('has local data:', configDirective.getConfigData()['site-settings']['has_local_data']);
		}
		this.detailDataInfo["DATA_PLAN"] = "Unknown";
		this.detailDataInfo["balance"] = "Unknown";
		this.dataPlan = "Unknown";

		this.$root.$on("simInfoLoad", info => {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] simInfoLoad...", Date());
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] simInfoLoad [INFO]", info);

			//console.error('SET IMSI ON simInfoLoad:',JSON.stringify(info));
			this.detailInfo = info;
			this.detailInfo["IMSI"] = info.IMSI;
			this.detailInfo["RoamingIMSI"] = info.RoamingIMSI;
			this.detailInfo["ICCID"] = info["ICCID"];
			this.detailInfo["MSISDN"] = info.MSISDN;
			this.detailInfo["IP"] = "Unknown";
			this.detailInfo["Cell ID"] = "Unknown";
			this.detailInfo["SIM Type"] = "Combo";
			this.detailInfo["Product"] = info.product;
			this.imsi = info.IMSI;
			if (info["hss_subscribername"]) this.subscriber_name = info["hss_subscribername"];
			//this.stateReadOnly = (info.status !== 'Active');
			this.gStatus = info.status !== "Active";
			this.lteStatus = info.status !== "Active";
			this.simStatus = info.status !== "Active";
		});

		this.$root.$on("simUsage", usage => {
			if (usage.sms) this.simUsage["SMS Inbox"] = usage.sms;
			if (usage.data) this.simUsage["Usage"] = usage.data;
		});

		this.$root.$on("simDetailInfo", info => {
			this.detailInfo = info;
			this.showQRCode();
		});

		this.$root.$on("simDetailLookSubscriber", info => {
			// console.log("simDetailLookSubscriber", info);

			this.detailSubscriber = info;
			this.dataPlan = info["DATA_PLAN"];
			this.dataPlanSelected = info["DATA_PLAN_DESC"];
			this.localDataChecked = info["LocaDataOnly"] === "Yes";
			this.localDataOnly = info["LocaDataOnly"];
			// this.isLoading = false;
			this.gStatus = info["2G_3G_Status"] === "Active";
			this.detailInfo["ICCID"] = info["ICCID"];
			this.imsi = info["IMSI"];
			this.roamingImsi = info["RoamingIMSI"];
			this.lteStatus = info["LTE_Status"] === "Active";
			this.smsStatus = info["SMS"] === "Yes";
			this.callWaitingStatus = info["Call_Waiting"] === "Yes";
			this.clipStatus = info["Clip"] === "Yes";
			this.mmsStatus = info["MMS"] === "Yes";
			this.simStatus = info["Status"] !== "Active";
			this.roamingStatus = info["RoamingStatus"] === "Active";
			this.tisStatus = info["TIS_Status"] === "Yes";
			this.url = info["url"];

			// console.log("roamingStatus:", info["RoamingStatus"] === "Active");
			// console.log("roamingStatus:", this.roamingStatus);

			// console.log('simestatus:',this.simStatus)
			// console.log('info[Status]:',info['Status'])
			// console.log('info:',info)

			this.getDropDowns();
			this.setCallForwardStatus();
			this.getConfigSiteSetting();
			this.isLoading = false;
			//if the Status is Active - then reset readonly state.
			if (info["Status"] === "Active") {
				this.stateReadOnly = initService.getReadOnlyRole();
			}
			if (process.env.NODE_ENV === "dev")
				console.warn("[DEBUG][SimeDetailCard.vue] simDetailLookSubscriber...END", Date());
		});

		this.$root.$on("simDetailDataInfo", info => {
			if (process.env.NODE_ENV === "dev")
				console.warn("[DEBUG][SimeDetailCard.vue] simDetailDataInfo...", Date());
			if (info) {
				this.detailDataInfo = info;
				if (info["DATA_PLAN"]) this.dataPlan = info["DATA_PLAN"] ? info["DATA_PLAN"] : "";
				else this.dataPlan = info["dataplan"] ? info["dataplan"] : "";
			}
		});

		this.$root.$on("simDetailOperator", info => {
			if (process.env.NODE_ENV === "dev")
				console.warn("[DEBUG][SimeDetailCard.vue] simDetailOperator...", Date());
			if (info) {
				this.detailOperator = info;
			}
		});

		this.$root.$on("simDetailFailedResponse", res => {
			if (process.env.NODE_ENV === "dev")
				console.warn("[DEBUG][SimeDetailCard.vue] simDetailFailedResponse...", Date());
			if (res) {
				this.isLoading = false;
				this.simDetailFailed = true;
			}
		});
		this.isAdminStatus = initService.getEditorRole();
	},
	methods: {
		async getConfigSiteSetting() {
			if (process.env.NODE_ENV === "dev")
				console.warn("[DEBUG][SimeDetailCard.vue] getConfigSiteSetting...", Date());
			let siteConfig = configDirective.getConfigSiteSetting();
			if (siteConfig["api_suspend_data"] !== null || siteConfig["api_slow_data"] !== null) {
				if (siteConfig["api_suspend_data"] === this.detailSubscriber["HSS_Profile"]) {
					this.hss_profile_badge_title = "Suspended";
				} else if (siteConfig["api_slow_data"] === this.detailSubscriber["HSS_Profile"]) {
					this.hss_profile_badge_title = "Throttled";
				} else {
				}
			}
		},

		async getDropDowns() {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] getDropDowns...", Date());
			this.getHlrProfile();
			this.getHssProfile();
			if (this.hasDataPlans) {
				this.getDataPlans();
			}
		},

		async getHlrProfile() {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] getHlrProfile...", Date());
			this.showLoadingHlrProfile = true;
			//console.log('showLoadingHlrProfile:',this.showLoadingHlrProfile);
			this.loadingMessage = "Loading HLR profile...";
			this.hlrProfile = this.detailSubscriber["HLR_Profile"];
			searchDashboardService.getHlrProfileSelectOption().then(res => {
				if (res) {
					let items = [];
					items.push({key: "", value: "Not Set"});
					res.map(item => {
						if (item.product !== "") items.push({key: item.product, value: item.description});
						if (item.product === this.hlrProfile) this.hlrProfileSelected = item.product;
					});
					this.hlrProfileOptions = items;
					if (this.hlrProfileSelected === "" || this.hlrProfileSelected === "undefined")
						this.hlrProfileSelected = items[0].product;
				}
				this.showLoadingHlrProfile = false;
				//console.log('showLoadingHlrProfile:',this.showLoadingHlrProfile);
			});
		},

		async getHssProfile() {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimDetailCard.vue] getHssProfile...", Date());
			this.showLoadingHssProfile = true;
			//console.log('showLoadingHssrProfile:',this.showLoadingHssProfile);
			this.loadingMessage = "Loading HSS profile...";
			this.hssProfile = this.detailSubscriber["HSS_Profile"];
			searchDashboardService.getHSSProfileSelectOption().then(res => {
				if (res) {
					let items = [];
					items.push({key: "", value: "Not Set"});
					if (res["results"] && res["results"]["list-item"]) {
						res["results"]["list-item"].map(item => {
							items.push({key: item.name, value: item.name});
							if (item.name === this.hssProfile) this.hssProfileSelected = item.name;
						});
					}
					this.hssProfileOptions = items;
					// console.log("hss_profile_selected:", this.hssProfileSelected);
					if (this.hssProfileSelected === "" || this.hssProfileSelected === "undefined") {
						this.hssProfileSelected = items[0].key;
					}
				}
				this.showLoadingHssProfile = false;
				//console.log('showLoadingHssProfile:',this.showLoadingHssProfile);
			});
		},

		async getDataPlans() {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] getDataPlans...", Date());
			this.showLoadingDataPlans = true;
			//console.log('showLoadingDataPlans:',this.showLoadingDataPlans);
			this.loadingMessage = "Loading Data plans...";
			//if (this.dataPlanOptions.length > 0) return;
			searchDashboardService.getDataBucketList("default").then(res => {
				//console.log('dataPlan:',this.dataPlan);
				//console.log('dataPlanSelected:',this.dataPlanSelected);
				let items = [];
				items.push({key: "", value: "Not Set"});
				if (res) {
					let i = 0;
					res.map(item => {
						i++;
						if (item.value.split("default_")[1]) {
							//item.text = item.value.split('default_')[1] + ' : ' + item.text;
							item.value = item.value.split("default_")[1];
						}
						items.push({value: item.text, key: item.value});
						//console.log(i,':',items[i]);
						if (items[i].value === this.dataPlanSelected) this.dataPlanSelected = items[i].key;
					});
					this.dataPlanOptions = items;
					if (this.dataPlanSelected === "" || this.dataPlanSelected === "undefined" || !this.dataPlanSelected)
						this.dataPlanSelected = items[0].key;
				}
				this.showLoadingDataPlans = false;
				//console.log('showLoadingDataPlans:',this.showLoadingDataPlans);
			});
		},

		sendPSI(imsi) {
			// console.log("sendPSI", imsi);
			setTimeout(() => {
				this.$root.$emit("sendPSI", imsi);
			}, 2000);
		},

		async getHssInfoDetail(imsi) {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] getHssInfoDetail...", Date());
			searchDashboardService.getHSSInfo(imsi).then(res => {
				// console.log("getHssInfoDetail:", res);
				this.$root.$emit("hssInfo", res);
			});
		},

		async getHlrInfoDetail(imsi) {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] getHlrInfoDetail...", Date());
			searchDashboardService.getHLRInfo(imsi).then(res => {
				this.$root.$emit("hlrInfo", res);
			});
		},

		async getMapDetail(imsi) {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] getMapDetail...", Date());
			searchDashboardService.getViewMap(imsi).then(res => {
				if (!res["ERROR"]) {
					this.$root.$emit("viewMap", res);
				} else {
					this.$root.$emit("viewMap", res["ERROR"]);
				}
			});
		},

		async getSessionDetail(imsi) {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] getSessionDetail...", Date());
			searchDashboardService.getSessionData(imsi).then(res => {
				this.$root.$emit("sessionData", res);
			});
		},

		async getSmsActivityDetail(imsi) {
			if (process.env.NODE_ENV === "dev")
				console.warn("[DEBUG][SimeDetailCard.vue] getSmsActivityDetail...", Date());
			searchDashboardService.getSMSActivity(imsi).then(res => {
				this.$root.$emit("SMSActivityDetail", res);
			});
		},

		async getSmsDetail(msisdn) {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] getSmsDetail...", Date());
			setTimeout(() => {
				this.$root.$emit("sendSMSModal", msisdn);
			}, 2000);
		},

		async setCallForwardStatus() {
			if (process.env.NODE_ENV === "dev")
				console.warn("[DEBUG][SimeDetailCard.vue] setCallForwardStatus...", Date());
			this.cfnaProvisionedStatus = this.detailSubscriber["CFNA_Provisioned"] === "Yes";
			this.cfnaActiveStatus = this.detailSubscriber["CFNA_Active"] === "Yes";
			this.cfnaNumber = this.detailSubscriber["CFNA_Number"];
			this.cfbProvisionedStatus = this.detailSubscriber["CFB_Provisioned"] === "Yes";
			this.cfbActiveStatus = this.detailSubscriber["CFB_Active"] === "Yes";
			this.cfbNumber = this.detailSubscriber["CFB_Number"];
			this.cfnrProvisionedStatus = this.detailSubscriber["CFNR_Provisioned"] === "Yes";
			this.cfnrActiveStatus = this.detailSubscriber["CFNR_Active"] === "Yes";
			this.cfnrNumber = this.detailSubscriber["CFNR_Number"];
			this.cfuProvisionedStatus = this.detailSubscriber["CFU_Provisioned"] === "Yes";
			this.cfuActiveStatus = this.detailSubscriber["CFU_Active"] === "Yes";
			this.cfuNumber = this.detailSubscriber["CFU_Number"];
		},

		async setModifySubscriber(action, value) {
			if (process.env.NODE_ENV === "dev") {
				console.warn("[DEBUG][SimeDetailCard.vue] setModifySubscriber...", Date());
			}
			this.$root.$emit("loadingPanelShow", true);
			// console.log("setModifySubscriber.action", action, ".value.", value);
			let field;
			if (value) {
				field = "Yes";
			} else {
				field = "No";
			}
			let err_status = false;
			// SetTIS param adjustments
			let imsi = this.imsi;
			if (action === "SetTIS") {
				imsi = this.roamingImsi;
				field = this.tisStatus ? 1 : 0;
			}
			await provisioningService
				.submitModifySubscriber(imsi, action, field)
				.then(res => {
					// console.log('submitModifySubscriber:',res);
					if (res && (JSON.stringify(res).includes("error") || JSON.stringify(res).includes("FAIL"))) {
						// console.log('submitModifySubscriber[ERROR]', res);
						err_status = true;
						this.$toast.error({
							component: ToastVue,
							props: {
								subtitle: "Modify Subscriber Failed:",
								description: res,
							},
						});
					} else {
						// console.log('submitModifySubscriber[OK]',commonService.parseJsonToHtml(res));
						err_status = false;
						this.$toast.success(
							{
								component: ToastVue,
								props: {
									subtitle: "Modify Subscriber",
									description: res,
								},
							},
							{
								timeout: 45000,
							}
						);
					}
					this.$root.$emit("loadingPanelHide", true);
				})
				.catch(err => {
					// console.log('submitModifySubscriber[CATCH][ERROR]',commonService.parseJsonToHtml(err));
					err_status = true;
					this.$toast.error({
						component: ToastVue,
						props: {
							subtitle: "Modify Subscriber Failed:",
							description: res,
						},
					});
				});

			//'LTE_Status', lteStatus
			if (action === "LTE_Status") {
				//console.log("hss profile options:", this.hssProfileOptions);
				if (err_status) {
					if (value) {
						this.lteStatus = false;
						this.hssProfileSelected = "";
					} else {
						this.lteStatus = true;
						//this.hssProfileSelected = this.hssProfileOptions[1].key;
					}
				} else {
					if (value) {
						this.lteStatus = true;
						this.hssProfileSelected = this.hssProfileOptions[1].key;
					} else {
						this.lteStatus = false;
						this.hssProfileSelected = "";
					}
				}
			}
		},

		async setCallingForward(field, validate, value) {
			if (process.env.NODE_ENV === "dev")
				console.warn("[DEBUG][SimeDetailCard.vue] setCallingForward...", Date());
			if (validate) {
				this.$root.$emit("loadingPanelShow", true);
				await provisioningService.submitModifySubscriber(this.imsi, field, value.toString()).then(res => {
					if (res && (JSON.stringify(res).includes("error") || JSON.stringify(res).includes("FAIL"))) {
						this.$toast.error({
							component: ToastVue,
							props: {
								subtitle: "Modify Subscriber Failed:",
								description: commonService.parseJsonToHtml(res),
							},
						});
					} else {
						this.$toast.success(
							{
								component: ToastVue,
								props: {
									subtitle: "Modify Subscriber:",
									description: commonService.parseJsonToHtml(res),
								},
							},
							{
								timeout: 45000,
							}
						);
					}
					this.$root.$emit("loadingPanelHide", true);
				});
			} else {
				this.$toast.error({
					component: ToastVue,
					props: {
						subtitle: "Modify Subscriber:",
						description: "Input Validate Number",
					},
				});
				this.$root.$emit("loadingPanelHide", true);
			}
		},

		async setCancelLocation(imsi) {
			if (process.env.NODE_ENV === "dev")
				console.warn("[DEBUG][SimeDetailCard.vue] setCancelLocation...", Date());

			setTimeout(() => {
				this.$root.$emit("cancelLocationData", imsi);
			}, 2000);
		},

		async setLocalData(data, imsi) {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] setLocalData...", Date());

			this.$root.$emit("loadingPanelShow", true);
			let value;
			if (data) {
				this.localDataOnly = "Yes";
				value = 1;
			} else {
				this.localDataOnly = "No";
				value = 0;
			}

			// console.log('localDataOnly',this.localDataOnly);
			// console.log('data',data);
			// console.log('localDataChecked',this.localDataChecked);

			await searchDetailService.setLocalDataByIMSI(value, imsi).then(res => {
				if (res && (JSON.stringify(res).includes("error") || JSON.stringify(res).includes("FAIL"))) {
					this.$toast.error({
						component: ToastVue,
						props: {
							subtitle: "Modify Subscriber Failed:",
							description: commonService.parseJsonToHtml(res),
						},
					});
				} else {
					this.$toast.success({
						component: ToastVue,
						props: {
							subtitle: "Modify Subscriber:",
							description: res["success"][0],
						},
					});
				}
			});
			this.$root.$emit("loadingPanelHide", true);
			//window.location.reload();
			this.$forceUpdate();
		},

		async setHlrProfile(data, imsi) {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] setHlrProfile...", Date());

			if (!data || data === "undefined" || data === "Not Set") {
				this.$toast.error({
					component: ToastVue,
					props: {
						subtitle: "Modify Subscriber Failed:",
						description: "Invalid Data Selection",
					},
				});
				return;
			}
			this.$root.$emit("loadingPanelShow", true);
			await provisioningService.submitModifySubscriber(imsi, "HLR_Profile", data).then(res => {
				if (res && (JSON.stringify(res).includes("error") || JSON.stringify(res).includes("FAIL"))) {
					this.$toast.error({
						component: ToastVue,
						props: {
							subtitle: "Modify Subscriber Failed:",
							description: commonService.parseJsonToHtml(res),
						},
					});
				} else {
					this.$toast.success(
						{
							component: ToastVue,
							props: {
								subtitle: "Modify Subscriber:",
								description: commonService.parseJsonToHtml(res),
							},
						},
						{
							timeout: 45000,
						}
					);
				}
			});
			this.$root.$emit("loadingPanelHide", true);
		},

		async setHssProfile(data, imsi) {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] setHssProfile...", Date());

			if (!data || data === "undefined" || data === "Not Set" || data === "") {
				// this.$toast.error({
				// 	component: ToastVue,
				// 	props: {
				// 		subtitle: "Modify Subscriber Failed:",
				// 		description: "Invalid Data Selection",
				// 	},
				// });
				await this.setModifySubscriber("LTE_Status", false);
				this.lteStatus = false;
				return;
			}
			this.$root.$emit("loadingPanelShow", true);
			await provisioningService.submitModifySubscriber(imsi, "HSS_Profile", data).then(res => {
				if (res && (JSON.stringify(res).includes("error") || JSON.stringify(res).includes("FAIL"))) {
					this.$toast.error({
						component: ToastVue,
						props: {
							subtitle: "Modify Subscriber Failed:",
							description: commonService.parseJsonToHtml(res),
						},
					});
				} else {
					this.$toast.success({
						component: ToastVue,
						props: {
							subtitle: "Modify Subscriber:",
							description: commonService.parseJsonToHtml(res),
						},
					});
					this.lteStatus = true;
				}
			});
			this.$root.$emit("loadingPanelHide", true);
		},

		async setDataPlan(data, imsi) {
			if (process.env.NODE_ENV === "dev") console.warn("[DEBUG][SimeDetailCard.vue] setDataPlan...", Date());

			if (!data || data === "undefined" || data === "Not Set") {
				this.$toast.error(
					{
						component: ToastVue,
						props: {
							subtitle: "Modify Subscriber Failed:",
							description: "Invalid Data Selection",
						},
					},
					{
						timeout: 45000,
					}
				);
				return;
			}
			this.$root.$emit("loadingPanelShow", true);
			await provisioningService.submitModifySubscriber(imsi, "DATA_PLAN", data).then(res => {
				if (res && (JSON.stringify(res).includes("error") || JSON.stringify(res).includes("FAIL"))) {
					this.$toast.error({
						component: ToastVue,
						props: {
							subtitle: "Modify Subscriber Failed:",
							description: commonService.parseJsonToHtml(res),
						},
					});
				} else {
					this.$toast.error(
						{
							component: ToastVue,
							props: {
								subtitle: "Modify Subscriber:",
								description: commonService.parseJsonToHtml(res),
							},
						},
						{
							timeout: 45000,
						}
					);
				}
				this.dataPlan = data;
			});
			this.$root.$emit("loadingPanelHide", true);
		},

		async setTisStatus() {
			if (process.env.NODE_ENV === "dev") {
				console.warn("[DEBUG][SimeDetailCard.vue] setTisStatus...", Date());
			}

			this.$root.$emit("loadingPanelShow", true);

			await this.removeSubscriberSubmit(this.imsi);

			// this.$root.$emit("loadingPanelHide", true);
		},

		async activateSubscriberSubmit() {
			let data = {
				iccidInfo: this.detailInfo["ICCID"],
				imsiInfo: this.imsi,
				msisdnInfo: this.detailInfo["MSISDN"],
				subscriberNameInfo: this.subscriber_name,
				//TODO: Check this value ^
				hssProfileInfo: this.hssProfileSelected,
				hlrProfileInfo: this.hlrProfile,
				// cbf_hlr_status,
				busyActive: this.cfbActiveStatus ? 1 : 0,
				// cbf_number,
				busyNumber: this.cfbNumber,
				// cbf_profile_status,
				busyProvision: this.cfbProvisionedStatus ? 1 : 0,
				// cfna_hlr_status,
				notAvailableActive: this.cfnaActiveStatus ? 1 : 0,
				// cfna_number,
				notAvailableNumber: this.cfnaNumber,
				// cfna_profile_status,
				notAvailableProvision: this.cfnaProvisionedStatus ? 1 : 0,
				// cfnr_hlr_status,
				notReachableActive: this.cfnrActiveStatus ? 1 : 0,
				// cfnr_number,
				notReachableNumber: this.cfnrNumber,
				// cfnr_profile_status,
				notReachableProvision: this.cfnrProvisionedStatus ? 1 : 0,
				// cfu_hlr_status,
				unconditionalActive: this.cfuActiveStatus ? 1 : 0,
				// cfu_number,
				unconditionalNumber: this.cfuNumber,
				// cfu_profile_status,
				unconditionalProvision: this.cfuProvisionedStatus ? 1 : 0,
				clip_profile_status: this.clipStatus ? 1 : 0,
				// cw_profile_status,
				callWaiting: this.callWaitingStatus ? 1 : 0,
				// data,
				enableData: this.dataPlanSelected ? 1 : 0,
				localData: this.localDataOnly ? 1 : 0,
				mms: this.mmsStatus ? 1 : 0,
				sms: this.smsStatus ? 1 : 0,
				tis: this.tisStatus ? 1 : 0,
				lte: this.lteStatus ? 1 : 0,
			};
			// console.log('setTisStatus [data]',data);
			// console.log('setTisStatus [roamingStatus]',this.roamingStatus);

			//this.$root.$emit('setSimStatus', 'Pending');
			// this.$bvModal.show("activity_progress_bar");
			// this.progressTitle = "Processing Actions";
			// this.progressMessage = "Adding Subscriber...";
			// this.setProgressTimer();

			await provisioningService
				.submitAddSubscriber(data)
				.then(queueid => {
					if (typeof queueid === "undefined") throw new Error("ADD ACTION failed.");
					provisioningService
						.getPollUntilDone(queueid, 60000, 1000, this.processMessage)
						.then(response => {
							this.$root.$emit("reloadSimDetailPageData", this.imsi);
							this.$root.$emit("loadingPanelHide", true);
						})
						.catch(err => {
							console.error(err);
							let msg = [];
							msg.status = "ERROR";
							msg.details = err.toString();
							this.processMessage(msg);
							this.$root.$emit("loadingPanelHide", true);
						});
				})
				.catch(err => {
					console.error(err);
					let msg = [];
					msg.status = "ERROR";
					msg.details = err.toString();
					this.processMessage(msg);
					this.$root.$emit("loadingPanelHide", true);
				});

			// this.tisStatus = !this.tisStatus;
		},

		removeSubscriberSubmit(imsi) {
			if (process.env.NODE_ENV === "dev")
				console.warn("[DEBUG][SimDetail.vue] removeSubscriberSubmit...", Date.now(), Date());
			let re = /^[0-9]{15}$/gm;
			if (!re.test(imsi)) {
				let msg = {
					status: "ERROR",
					response: {
						error: "Invalid IMSI: " + imsi,
					},
				};
				this.processMessage(msg);
				return;
			}

			// this.$bvModal.show('activity_progress_bar');
			// this.progressTitle = 'Processing Actions';
			// this.progressMessage = 'Removing Subscriber...';
			// this.setProgressTimer();

			provisioningService
				.submitRemoveSubscriber(imsi)
				.then(queueid => {
					if (process.env.NODE_ENV === "dev")
						console.warn("[DEBUG][SimDetail.vue] submitTerminateSubscriber.queueid:", queueid);
					if (typeof queueid === "undefined") throw new Error("TERMINATE ACTION failed.");
					provisioningService
						.getPollUntilDone(queueid, 60000, 1000, this.processMessage)
						.then(async response => {
							if (process.env.NODE_ENV === "dev")
								console.warn("[DEBUG][SimDetail.vue] getPollUntilDone.response:", response);
							if (response.status && response.status === "DONE") {
								// this.processMessage(response);
								await this.activateSubscriberSubmit();
							}
						})
						.catch(e => {
							console.error(e);
							let msg = [];
							msg.status = "ERROR";
							msg.details = e.toString();
							this.processMessage(msg);
							this.$root.$emit("loadingPanelHide", true);
						});
				})
				.catch(e => {
					console.error(e);
					let msg = [];
					msg.status = "ERROR";
					msg.details = e.toString();
					this.processMessage(msg);
					this.$root.$emit("loadingPanelHide", true);
				});
		},

		setProgressTimer() {
			this.timer = setInterval(() => {
				this.progressStartValue = this.progressStartValue + (Math.random() * 300) / this.progressStartValue;
				if (this.progressStartValue > 100) {
					this.progressStartValue = 10;
				}
			}, 1000);
		},

		showQRCode() {
			if (this.detailInfo["SIM Type"] === "eSIM") {
				this.showQRCodeStatus = true;
			} else {
				this.showQRCodeStatus = false;
			}
		},

		getProfile(iccid) {
			this.$router.push({path: `/eSIM/profile/:?iccid=${iccid}&action=order_show_barcode`});
		},

		processMessage(msg) {
			if (!msg || String(msg).length < 5) return;
			if (JSON.stringify(this.lastMessage) === JSON.stringify(msg)) return;
			if (process.env.NODE_ENV === "dev") {
				console.log("ACTIVATE:", msg);
			}

			if (
				JSON.stringify(msg).toLowerCase().indexOf("error") ||
				JSON.stringify(msg).toLowerCase().indexOf("fail")
			) {
				msg.status === "ERROR";
			}

			if (msg.response)
				if (msg.status === "DONE" || msg.status === "ERROR") {
					let messageData = "";
					if (msg && msg.response) {
						try {
							let j = JSON.parse(msg.response);
							if (j.success) {
								//console.log('s:', j.success);
								j.success.map(item => {
									messageData =
										messageData +
										item
											.replaceAll('"', "")
											.replaceAll("{", "")
											.replaceAll("}", "")
											.replaceAll("[", "")
											.replaceAll("]", "")
											.replaceAll('"', "")
											.replaceAll('"', "") +
										`<br>`;
								});
							}
							if (j.error) {
								j.error.map(item => {
									messageData = messageData + item + `<br>`;
								});
							}
						} catch (e) {
							//console.error(e);
						} //ignore
					}

					if (msg.status === "ERROR") {
						if (typeof msg.details !== "undefined") {
							msg.details =
								"There was an error completing the International Roaming operation.  Please try again or refer to the logs for more details.<br>" +
								messageData;
							this.$toast.success(
								{
									component: ToastVue,
									props: {
										title: "International Roaming Operation:",
										subtitle:
											"There was an error completing the International Roaming operation.  Please try again or refer to the logs for more details.",
										description: JSON.stringify(messageData),
									},
								},
								{
									timeout: 45000,
								}
							);
						} else {
							this.$toast.success(
								{
									component: ToastVue,
									props: {
										title: "International Roaming Operation:",
										description: JSON.stringify(messageData),
									},
								},
								{
									timeout: 45000,
								}
							);
						}
					} else {
						msg.details = "<br>" + messageData;
						this.$toast.success(
							{
								component: ToastVue,
								props: {
									subtitle: "International Roaming Operation Complete:",
									description: msg.details,
								},
							},
							{
								timeout: 45000,
							}
						);
					}
					// this.closeModal();
				} else {
					this.progressMessage = msg.status;
				}
			this.lastMessage = msg;
		},
	},
};
</script>
